import { render } from "./OrthoAddPartners.vue?vue&type=template&id=7fad0d32"
import script from "./OrthoAddPartners.vue?vue&type=script&lang=js"
export * from "./OrthoAddPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__